module.exports = __webpack_public_path__ + "static/media/ecp.a47d8dbb.svg";